import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
const InitSwal = withReactContent(Swal)

export default InitSwal